import React from "react";
import { UserAuth } from "../../context/AuthContext";
import FloatingButton from "../../components/Buttons/FloatingButton/FloatingButton";
import DeveloperCarousel from "../../components/DeveloperCarousel/DeveloperCarousel";
import HeaderElement from "../../components/HeaderElement/HeaderElement";
import "./Developer.css";
import data from "../../locales/ro.json"

const Developer = () => {

  //this handles the dropdown
  const [version, setVersion] = React.useState(Object.keys(data.dnd)[0]);
  const handleChange = (e) => {
    console.log(e.target)
    setVersion(e.target.value);
  };


  return (
    <div>
      <HeaderElement headerText={"Meet the D&Ds"} />
      <div className="devVersionSelectWrapper">
        <select
          className="devVersionSelect"
          name="versionSelect"
          onChange={handleChange}
        >
          {
            Object.keys(data.dnd).map((key) => {
              return <option>{key}</option>
            })
          }
        </select>
      </div>
      <DeveloperCarousel
        devArr={data.dnd[version]["templieri"]}
        title={"Templieri"}
      />
      <DeveloperCarousel
        devArr={data.dnd[version]["arhitecti"]}
        title={"Arhitecti"}
      />
    </div>
  );
};

export default Developer;
